import { api1 } from "./Api";

export const LicenceApis = {
    getCustomerType: () => api1.get(`/customer-types`),
    EligiblePlans: (id) => api1.get(`/plans/findEligibleForCustomerType/${id}`),
    createSubscriptions: (data) => api1.post("/subscriptions", data),
    createPrimaryContact: (data) => api1.post("/primaryContact/savePrimaryContact", data),
};